// extracted by mini-css-extract-plugin
export default {"mapCanvas":"FieldMap_mapCanvas__syXRi"};